"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnvEndpoints = void 0;
var getEnvEndpoints = exports.getEnvEndpoints = function getEnvEndpoints() {
  var isUpgrade = Boolean(process.env.REACT_APP_SERVER_UPGRADE && process.env.REACT_APP_SERVER_UPGRADE === "1");
  if (isUpgrade) {
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL_NEW || 'https://management-idbf.inexture.in'
    };
  } else {
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL || 'https://management.100procentlokaal.be'
    };
  }
};